import { render, staticRenderFns } from "./FImage.vue?vue&type=template&id=6b88e0c4&scoped=true&"
import script from "./FImage.vue?vue&type=script&lang=ts&"
export * from "./FImage.vue?vue&type=script&lang=ts&"
import style0 from "./FImage.vue?vue&type=style&index=0&id=6b88e0c4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b88e0c4",
  null
  
)

export default component.exports